import { Testimonial } from "@/lib/types";

export const testimonialData: Testimonial[] = [
  {
    id: "1",
    quote:
      "\u201COctarnal took our vision for Moson Media and turned it into a high-converting digital experience. Their understanding of SaaS positioning and conversion-driven design helped us stand out in a crowded market. Truly exceptional work.\u201D",
    authorName: "WASELL CHOWDHURY",
    authorRole: "Founder, Moson Media",
    image: "/assets/images/wasell.jpg",
    authorAvatar: "/assets/images/wasell.jpg",
  },
  {
    id: "2",
    quote:
      "\u201CFrom zero to BDT 3 million in revenue \u2014 Octarnal didn\u2019t just build us a website, they built us a growth engine. The premium design and seamless shopping experience they created for Elorva Perfumes exceeded every expectation.\u201D",
    authorName: "WAHED CHOWDHURY",
    authorRole: "Founder, Elorva Perfumes",
    image: "/assets/images/wahed.jpeg",
    authorAvatar: "/assets/images/wahed.jpeg",
  },
  {
    id: "3",
    quote:
      "\u201COctarnal understood our brand at a level that surprised us. They designed a website for Artevic Media that lets our cinematic work speak for itself while driving real client inquiries. The results have been phenomenal.\u201D",
    authorName: "NUR ALAM SHAKIB",
    authorRole: "Founder, Artevic Media",
    image: "/assets/images/nur.jpg",
    authorAvatar: "/assets/images/nur.jpg",
  },
];
